/* eslint-disable react/no-unescaped-entities */
import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/styles";
import { useHistory } from "react-router-dom";

const ErrorComponent = (props) => {
  const [showPopup, setShowPopup] = useState(true);
  const { axiosErrorResponse } = props;
  const history = useHistory();
  const themeObj = useTheme();
  const matches = useMediaQuery(themeObj.breakpoints.down("md"));
  return (
    <>
      <Dialog
        open={!axiosErrorResponse?.success && showPopup}
        className="info-dialog"
      >
        <DialogContent sx={{ padding: "40px" }}>
          <Box mb={6}>
            <Typography
              variant="h2LatoBold"
              component="div"
              sx={{
                color: themeObj.palette.common.textGrey2,
                fontFamily: "Lato-Regular",
                marginBottom: "12px",
              }}
            >
              We're sorry.
            </Typography>
            <Typography
              variant="h2LatoBold"
              sx={{
                color: themeObj.palette.common.textGrey2,
                fontFamily: "Lato-Regular",
              }}
            >
              {axiosErrorResponse?.message}
            </Typography>
          </Box>
          <Box mb={2}>
            <Button
              variant="large"
              onClick={() => {
                setShowPopup(false);
                history.push("/");
              }}
              sx={{ minWidth: matches ? "150px" : undefined }}
            >
              TRY AGAIN
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ErrorComponent;
